import { useState } from 'react';
import { Check, CircleSlash } from 'lucide-react';
import { Button } from '@/ui/primitives';
import { useTriagem } from '../../api';
import type { StatusSinal } from '../../schemas';

interface Props {
  id: string;
}

// Triagem do analista — só aparece em sinal_detectado / triagem.
// Confirma o sinal, marca duplicado ou registra como ruído (com justificativa).
export function FaseTriagem({ id }: Props) {
  const triagem = useTriagem(id);
  const [ruidoFormOpen, setRuidoFormOpen] = useState(false);
  const [ruidoMotivo, setRuidoMotivo] = useState('');

  function onTriagem(status: StatusSinal, motivo?: string) {
    triagem.mutate({ status_sinal: status, ...(motivo ? { motivo } : {}) });
  }
  function onConfirmarRuido() {
    if (!ruidoMotivo.trim()) return;
    onTriagem('ruido', ruidoMotivo.trim());
    setRuidoFormOpen(false);
    setRuidoMotivo('');
  }

  return (
    <section>
      <h3 className="text-[0.78rem] font-semibold uppercase tracking-wide text-text-muted mb-2">
        Triagem do analista
      </h3>
      <div className="flex flex-wrap gap-2">
        <Button
          variant="primary"
          size="sm"
          onClick={() => onTriagem('confirmado')}
          disabled={triagem.isPending}
        >
          <Check size={14} /> Confirmar
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onTriagem('duplicado')}
          disabled={triagem.isPending}
        >
          Duplicado
        </Button>
        {!ruidoFormOpen && (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setRuidoFormOpen(true)}
            disabled={triagem.isPending}
          >
            <CircleSlash size={14} /> Ruído
          </Button>
        )}
      </div>

      {ruidoFormOpen && (
        <div className="flex flex-col gap-2 pt-2 border-t border-border">
          <span className="text-[0.75rem] font-semibold text-text-muted uppercase tracking-wide">
            Justificativa do ruído *
          </span>
          <textarea
            className="input text-[0.82rem] resize-none"
            rows={3}
            placeholder="Descreva por que esta oportunidade é ruído..."
            value={ruidoMotivo}
            onChange={(e) => setRuidoMotivo(e.target.value)}
            autoFocus
          />
          <div className="flex gap-2">
            <Button
              variant="danger"
              size="sm"
              onClick={onConfirmarRuido}
              disabled={!ruidoMotivo.trim() || triagem.isPending}
            >
              <CircleSlash size={14} /> Confirmar ruído
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => { setRuidoFormOpen(false); setRuidoMotivo(''); }}
              disabled={triagem.isPending}
            >
              Cancelar
            </Button>
          </div>
        </div>
      )}
    </section>
  );
}
